import React, { type PropsWithChildren } from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';

const contentContainerStyles = xcss({
	margin: 'auto',
	maxWidth: '70rem',
	paddingLeft: 'space.100',
	paddingRight: 'space.100',
	boxSizing: 'content-box',
});

export const ContentContainer = ({ children }: PropsWithChildren<{}>): React.JSX.Element => {
	return <Box xcss={contentContainerStyles}>{children}</Box>;
};
